import type { ColumnsType } from "antd/es/table";
import { TableComponent } from "../../global/TableComponent";
import { PlatformsData } from "../../../helpers/interfaces/PlatformsInterfaces";

const columns: ColumnsType<PlatformsData> = [
  {
    title: "Id",
    dataIndex: "platform_id",
    key: "platform_id",
  },
  {
    title: "Platform Name",
    dataIndex: "platform_name",
    key: "platform_name",
  },
  {
    title: "Created By",
    dataIndex: "created_by",
    key: "created_by",
  },
  {
    title: "Created At",
    key: "created_at",
    dataIndex: "created_at",
  },
];

export const PlatformTableComponent = (props: any) => {
  const {
    tableProps,
    onPaginationChange,
    onSelectRow,
    selectedRowKey,
    selectionType,
  } = props;

  return (
    <div style={{ marginTop: "2%" }}>
      <TableComponent
        columns={columns}
        data={tableProps?.data ? tableProps.data.data : []}
        pagination={
          tableProps?.data
            ? { ...tableProps.data.meta, onChange: onPaginationChange }
            : {}
        }
        onSelectRow={onSelectRow}
        selectedRowKey={selectedRowKey}
        selectionType={selectionType}
      />
    </div>
  );
};
